import { create } from 'zustand';
import MuvikaService from '../services/muvika';
import { generateId } from '../services/random';
import accountStore from './account';
import ExternalViewCommands from '../services/external';
import IntervalService from '../services/intervals';
import messageStore from './message';
import playerStore from './player';
import TR from './../Trans';
import settingsStore from './settings';
import { sortBySmartQ } from '../services/smartq';
import { subscribeWithSelector } from 'zustand/middleware';
import { persist } from 'zustand/middleware';

const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

//const TWELVE_HOURS_MS = 1 * 60 * 1000;

const initialState = {
  isWaiting: false,
  currentUser: null,
  isQueueingOn: false,
  queue: null,
  history: null,
  ipCounts: {},
  idCounts: {}
};

const songbookQueueStore = create(subscribeWithSelector(persist((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setQueueingOn: (isOn) => {
    if (!isOn) {
      set({ queue: [] });
    }
    set({ isQueueingOn: isOn });
  },
  moveToTop: (reqId) => {
    console.log("moveToTop", reqId);
    let queue = get().queue;
    const index = queue.findIndex((q) => q.id === reqId);
    if (index === -1) return;

    const [item] = queue.splice(index, 1);
    queue.unshift(item);

    set({ queue: [...queue] });
  },

  moveToSecond: (reqId) => {
    let queue = get().queue;
    const index = queue?.findIndex((q) => q.id === reqId);
    if (index === -1) return;

    const [item] = queue.splice(index, 1);
    queue.splice(1, 0, item);

    set({ queue: [...queue] });
  },

  moveToBottom: (reqId) => {
    let queue = get().queue;
    const index = queue?.findIndex((q) => q.id === reqId);
    if (index === -1) return;

    const [item] = queue.splice(index, 1);
    queue.push(item);

    set({ queue: [...queue] });
  },

  moveUp: (reqId) => {
    let queue = get().queue;
    const index = queue?.findIndex((q) => q.id === reqId);
    if (index <= 0) return

      ;[queue[index - 1], queue[index]] = [queue[index], queue[index - 1]];

    set({ queue: [...queue] });
  },

  moveDown: (reqId) => {
    let queue = get().queue;
    const index = queue?.findIndex((q) => q.id === reqId);
    if (index === -1 || index === queue.length - 1) return

      ;[queue[index], queue[index + 1]] = [queue[index + 1], queue[index]];

    set({ queue: [...queue] });
  },
  move: (sourcePos, destPos) => {
    let queue = get().queue;

    if (
      sourcePos < 0 ||
      sourcePos >= queue?.length ||
      destPos < 0 ||
      destPos >= queue?.length ||
      sourcePos === destPos
    ) return;

    const [item] = queue.splice(sourcePos, 1);
    queue.splice(destPos, 0, item);

    set({ queue: [...queue] });
  },
  setIsWaiting: (isWaiting) => {
    set({isWaiting: isWaiting})
  },
  setQueue: (reqs) => {
    console.log("persisting: history", get().history)
    let queue = get().queue || [];
    const reqIds = new Set(reqs.map(r => r.id));
    queue = queue.filter(item => reqIds.has(item.id));
    for (let i = 0; i < reqs.length; i++) {
      const req = reqs[i];
      const index = queue.findIndex(x => x.id === req.id);

      if (index === -1) {
        console.log("setQueue adding to queue");
        queue.push({ ...req });
      } else {
        queue[index] = { ...queue[index], ...req };
      }
    }

    set({ queue: [...queue] });
  },
  updateRemoveHistory: () => {
    console.log("persisting: history", get().history)
    let history = get().history;
    if (history) {
      let dateNow = new Date();
      dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
      set({
        history: [...history.filter((item) => {
          console.log("updateRemoveHistory", dateNow, item.created, dateNow - new Date(item.created), dateNow - new Date(item.created) < TWELVE_HOURS_MS);
          return dateNow - new Date(item.created) < TWELVE_HOURS_MS;
        })],
      });
    }
  },
  setHistory: (reqs) => {
    console.log("persisting: history", get().history)
    let history = get().history;
    for (let i = 0; i < reqs.length; i++) {
      let req = reqs[i];
      if (history) {
        let itemId = history.findIndex(x => x.id == req.id);
        if (itemId == -1) {
          history.push({ ...req });
        }
      } else {
        history = [{ ...req }];
      }
    }
    set({ history: [...history] });
  },
  deleteFromQueue: (item) => {
    let queue = get().queue;
    console.log("deleting", item, queue);
    let itemId = queue.findIndex(x => x.id == item.id);
    console.log("deleting", itemId)
    if (itemId != -1) {
      queue.splice(itemId, 1);
      set({ queue: [...queue] });
      let history = get().history;
      console.log("deleting", history)
      if (history) {
        history.push({ ...item });
      } else {
        history = [{...item}];
      }
      console.log("deleting", history)
      set({ history: [...history] });
    }
  },
  setReqOld: (reqId) => {
    let queue = get().queue;
    let itemId = queue.findIndex(x => x.id == reqId);
    if (itemId != -1) {
      let item = queue[itemId];
      item.isNew = false;
      set({ queue: [...queue] });
    }
  }
}),
  {
    name: 'muvika-songbook-history-storage',
    getStorage: () => localStorage,
  }
)));

export default songbookQueueStore;